export namespace DynamicForm {
	export class OptionInfo {
		Id: number;
		ParentId: number;
		SortValue: number;
		Text: string;
	}
}
